export const API_ROUTES = {
  TEAM: "/team",
  MEMBERS: "/team/members",
  ALUMNI: "/team/alumni",
  TOKEN: "/token",
  REFRESH_TOKEN: "token/refresh/",
  EVENTS: "/events/",
  USERS: "/users",
  EXPERIENCES: "/experiences",
  HOME: "/",
  GET_STARTED: "/getting_started",
  ROLES: "/users/roles",
  LEADERBOARD: "/leaderboard",
};
